import script from "./EntityTypeBrowserDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityTypeBrowserDialog.vue?vue&type=script&setup=true&lang=js"

import "./EntityTypeBrowserDialog.vue?vue&type=style&index=0&id=572144eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-572144eb"]])

export default __exports__